<template>
  <div class="cartPage">
    <v-container>
      <v-stepper class="my-4 py-4" alt-labels :value="currentPage">
        <v-stepper-header>
          <v-stepper-step step="1" color="pink">確認清單</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="2" color="pink">付款方式</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="3" color="pink">填寫資料</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="4" color="pink">購物完成</v-stepper-step>
        </v-stepper-header>
        <router-view class="pa-8"></router-view>
      </v-stepper>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  computed: {
    currentPage() {
      if(this.$route.name == 'ShoppingCart') {
        return 1
      }
      else if(this.$route.name == 'Payment') {
        return 2
      }
      else if(this.$route.name == 'Checkout') {
        return 3
      }
      else if(this.$route.name == 'PaymentSuccessful') {
        return 4
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.cartPage {
  height: 100%;
  .container {
    padding: auto 0;
    max-width: 1200px;
    color: black !important;
    height: inherit;
    .v-stepper {
      margin: 0 !important;
      height: inherit;
    }
    .v-stepper__header {
      box-shadow: none;
    }
    .v-stepper__label {
      display: block !important;
      @include mobile {
        font-size: 12px;
      }
    }
    .v-stepper__step {
      @include mobile {
        flex-basis: unset;
      }
    }
    .overview {
      position: relative;
      font-weight: 500;
      font-size: 18px;
      &::after {
        content: '';
        width: 100%;
        height: 2px;
        background-color: black;
        position: absolute;
        left: 0;
        bottom: 0;
      }
    }
    a:not(.v-btn) {
      display: flex;
      align-items: center;
      color: black !important;
    }
    .cart-detail {
      padding-top: 20px;
      .cart-action {
        margin-top: 16px;
        display: flex;
        justify-content: space-between;
        .v-btn {
          width: 150px;
          @include mobile {
            width: 120px;
          }
        }
      }
    }
  }
}
</style>